<template>
  <div class="ny-date-range">
    <input
      type="text"
      readonly
      placeholder="请选择日期范围"
      class="ny-date-range__input"
      :class="{'is-disabled': disabled}"
      :disabled="disabled"
      v-model="currentDate"
      @click="showPanel = !showPanel"
    >
    <transition name="ny-date-range-slide">
      <div class="ny-date-range__panel-wrap" v-show="showPanel">
        <div class="ny-date-range__panel">
          <div class="ny-date-range__operate">
            <div class="ny-date-range__current">
              <span>开始</span>
              <input type="text" v-model="startDate" @change="e => this.handleChange('start', e.target.value)">
            </div>
            <div class="ny-date-range__current">
              <span>结束</span>
              <input type="text" v-model="endDate" @change="e => this.handleChange('end', e.target.value)">
            </div>
            <div class="ny-date-range__shortcut">
              <template v-if="shortcut">
                <div>
                  <span @click="setPastDate(-1)">昨天</span>
                  <span @click="setPastDate(-3)">过去3天</span>
                  <span @click="setPastDate(-5)">过去5天</span>
                  <span @click="setPastDate(-7)">过去7天</span>
                  <span @click="setPastDate(-15)">过去15天</span>
                  <span @click="setPastDate(-30)">过去30天</span>
                  <span @click="setPastMonth()">本月</span>
                  <span @click="setPastMonth(-1)">上个月</span>
                </div>
              </template>
            </div>
            <div class="ny-date-range__btn-group">
              <button @click="confirm">确定</button>
              <button @click="showPanel = false">取消</button>
            </div>
          </div>
          <div class="ny-date-range__picker">
            <ny-date-picker
              class="ny-date-range__picker-start"
              v-model="startDate"
              :disabled-date="disabledStartDate"
              @change="value => this.handleChange('start', value)"
            ></ny-date-picker>
            <ny-date-picker
              class="ny-date-range__picker-end"
              v-model="endDate"
              date-type="end"
              :disabled-date="disabledEndDate"
              :associated-date="startDate"
              @change="value => this.handleChange('end', value)"
            ></ny-date-picker>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import NyDatePicker from './index';
import { getDiffDate, formatDate, getBeginAndEndDateOfMonth } from '@/global/util/date';

export default {
  name: 'NyDateRange',
  components: {
    NyDatePicker
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    separator: {
      type: String,
      default: ' ~ '
    },
    shortcut: Boolean,
    disabled: Boolean,
    disabledStartDate: Function,
    disabledEndDate: Function
  },
  data () {
    return {
      startDate: formatDate(),
      endDate: formatDate(),
      currentDate: '',
      showPanel: false
    };
  },
  created () {
    if (this.value.length === 2) {
      this.setDate(this.value)
    }
  },
  methods: {
    setDate (value) {
      const [startDate, endDate] = value;
      this.currentDate = `${startDate}${this.separator}${endDate}`;
      this.startDate = startDate
      this.endDate = endDate
    },
    handleChange (type, value) {
      if (type === 'start') {
        this.startDate = value;
      } else if (type === 'end') {
        this.endDate = value;
      }
    },
    setPastDate (day) {
      const { startDate, endDate } = getDiffDate(day)
      this.startDate = startDate;
      this.endDate = endDate;
    },
    setPastMonth (month) {
      const [startDate, endDate] = getBeginAndEndDateOfMonth(month)
      this.startDate = startDate;
      this.endDate = endDate;
    },
    confirm () {
      const { startDate, endDate, separator } = this;
      this.showPanel = false;
      this.currentDate = `${startDate}${separator}${endDate}`;
      this.$emit('input', [startDate, endDate]);
      this.$emit('change', [startDate, endDate]);
    }
  },
  watch: {
    value (val) {
      this.setDate(val)
    }
  }
};
</script>

<style lang="scss">
.ny-date-range-slide-enter-active {
  transition: all 0.3s ease-in;
}
.ny-date-range-slide-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.ny-date-range-slide-enter,
.ny-date-range-slide-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

@include b(ny-date-range) {
  position: relative;

  @include e(input) {
    width: 205px;
    height: 28px;
    font-size: 14px;
    line-height: 28px;
    text-align: center;
    color: #0f1a23;
    outline: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bdbdbd;
    box-sizing: border-box;
    cursor: pointer;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

    &::-webkit-input-placeholder {
      color: #1d2b36;
    }

    @include is(disabled) {
      background-color: #eef1f6;
      border-color: #d1dbe5;
      color: #bbb;
      cursor: not-allowed;

      &::-webkit-input-placeholder {
        color: #bbb;
      }
    }
  }

  @include e(panel-wrap) {
    position: absolute;
    top: 35px;
    left: 0;
    z-index: 100;
    width: 764px;
    height: 352px;
    background: #fff;
    border-top: 10px solid #0e1922;
    border-radius: 3px 3px;
    box-shadow: 1px 11px 30px 5px #ccc;
  }

  @include e(operate) {
    float: left;
    width: 170px;
    height: 352px;
    border-right: 1px solid #f8f8f8;
  }

  @include e(current) {
    width: 154px;
    height: 30px;
    margin-top: 15px;
    margin-left: 9px;
    border: 1px solid utre;
    border-radius: 30px 30px;
    box-sizing: border-box;

    span {
      float: left;
      width: 54px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      color: #fff;
      background: #3dc1c4;
      border-radius: 30px 0 0 30px;
    }

    input {
      float: right;
      width: 98px;
      height: 28px;
      margin: 0;
      padding: 0;
      line-height: 28px;
      text-align: center;
      border-radius: 30px 30px;
      border: none;
      outline: none;
    }
  }

  @include e(shortcut) {
    width: 161px;
    height: 102px;
    margin-left: 9px;
    margin-top: 30px;

    span {
      display: inline-block;
      height: 22px;
      padding: 0 10px;
      line-height: 22px;
      text-align: center;
      font-size: 12px;
      border-radius: 30px 30px;
      margin-bottom: 10px;
      border: 1px solid #bac6ce;
      cursor: pointer;
      margin-right: 5px;
    }
    span:hover {
      color: #3dc1c4;
      border-color: #3dc1c4;
    }
  }

  @include e(btn-group) {
    margin-left: 9px;
    margin-top: 75px;

    button {
      float: left;
      width: 50px;
      height: 24px;
      margin: 0 10px;
      padding: 0;
      line-height: 24px;
      text-align: center;
      color: #fff;
      background: #3dc1c4;
      border: 1px solid #3dc1c4;
      border-radius: 3px 3px;
      cursor: pointer;
      outline: none;
    }
  }

  @include e(picker) {
    overflow: hidden;
  }

  @include e(picker-start) {
    float: left;
    border-right: 1px solid #f1f1f1;
  }

  @include e(picker-end) {
    float: right;
  }
}
</style>
